<template>
  <div v-if="order != null" class="point_confirm">
    <section class="text_center">
      <h2 class="header_underline">クレジットカード③決済確認</h2>
      <p>購入内容</p>
      <table class="table white brown">
        <tr>
          <th>決済金額</th>
          <th>追加ポイント</th>
        </tr>
        <tr>
          <td>{{ order.price.toLocaleString() }}円</td>
          <td>{{ order.point }}pt</td>
        </tr>
      </table>
      <form
        :action="product.action"
        method="post"
        class="form"
        ref="paymentForm"
      >
        <input type="hidden" v-for="(entry, index) in storeSettings" :key="index" :name="entry.name" :value="entry.value" />
        <input type="hidden" name="payment_code" value="10070">
        <input type="hidden" name="sendid" :value="sendId" />
        <input type="hidden" name="price" :value="order.price" />
        <input type="hidden" name="cookie" :value="orderNum" />
        <input type="hidden" name="sendpoint" :value="user.user.access_cd" />
        <input type="hidden" name="email" :value="user.user.mail" />
        <div>
          <p>
            <button
              type="submit"
              class="btn arrow"
              :disabled="isSend"
              @click="submit"
            >決済する</button>
          </p>
          <div class="caution">
            <p class="text_left font_annotation--text">上記「決済」をご選択されますと、テックコインクレジットカード入力画面へと遷移致します。その際、読み込みに数十秒程、要する事が御座いますので、予めご了承願います。</p>
            <p class="equality_margin text_left font_annotation--text">※セキュリティ保護のため、一度ご登録されたクレジットカード情報は、定期的にリセットさせて頂いております。お手数ですが、リセット後は再度カード情報をご入力頂けますようお願い致します。</p>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointCreditTechcoinConfirm',
  props: {
    order: Object,
    product: Object
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      isSend: false
    }
  },
  computed: {
    storeSettings () {
      const settings = []
      if (this.product.store_settings != null) {
        this.product.store_settings.map(g => {
          if (g.key) {
            settings.push({
              name: g.key,
              value: g.value
            })
          }
        })
      }
      return settings
    },
    sendId () {
      return this.order.environment + this.user.user.orig_id
    },
    orderNum () {
      return this.order.environment + this.order.id
    }
  },
  methods: {
    submit () {
      this.isSend = true
      this.$refs.paymentForm.submit()
    }
  },
  created () {
    if (this.order == null) {
      this.$router.pushIsses({ name: 'PointCreditTechcoinForm' })
    }
  }
}
</script>
